import styled from "styled-components"
import { MarkerStyles } from "./dropdown-marker-styles"

export const Marker = styled.span`
  font-size: 11px;
  margin-left: 10px;
  margin-top: 4px;
  ${MarkerStyles}
`
